/** @format */

import React from 'react';
import Header from '../../components/common/Header';
// lazy load footer
const Footer = React.lazy(() => import('../../components/common/Footer'));

const mentors = [
	{
		name: 'Adv. Rahul Sharma',
		expertise: 'Indian Contract Act & Answer Writing',
		description:
			'Practicing advocate with 10+ years of experience guiding law students in exam-oriented preparation and structured answer writing.',
		image: '/what-we-do.png',
	},
	{
		name: 'Prof. Ananya Iyer',
		expertise: 'Constitutional Law',
		description:
			'Law professor specializing in constitutional interpretation, landmark judgments, and exam-focused conceptual clarity.',
		image: '/what-we-do.png',
	},
	{
		name: 'Adv. Kunal Verma',
		expertise: 'Criminal Law (IPC & CrPC)',
		description:
			'Judicial exam mentor helping students master IPC sections, case laws, and problem-based questions.',
		image: '/what-we-do.png',
	},
	{
		name: 'Dr. Neha Mehta',
		expertise: 'Legal Research & Case Laws',
		description:
			'Academic mentor guiding students in effective case law analysis, legal reasoning, and exam presentation.',
		image: '/what-we-do.png',
	},
	{
		name: 'Adv. Ritesh Singh',
		expertise: 'Torts & Jurisprudence',
		description:
			'Focused on simplifying complex legal concepts and helping students score better through clarity and structure.',
		image: '/what-we-do.png',
	},
	{
		name: 'Prof. Pooja Nair',
		expertise: 'Family Law & Legal Writing',
		description:
			'Experienced educator supporting law students in consistency, confidence building, and exam strategy.',
		image: '/what-we-do.png',
	},
];

const Mentors: React.FC = () => {
	return (
		<body className='bg-white overflow-x-hidden p-0!'>
			<Header />

			<main className='min-h-screen py-20 px-4 bg-[#F6FBFD] scroll-mt-24'>
				{/* Page Heading */}
				<div className='text-center max-w-3xl mx-auto mb-14'>
					<h1 className='text-3xl md:text-4xl font-bold text-myButtonBg capitalize'>
						Our Mentors
					</h1>
					<p className='text-gray-700 mt-4 text-lg'>
						Learn from experienced legal professionals and educators who guide
						law students with exam-focused learning and practical insights.
					</p>
				</div>

				{/* Mentors Grid */}
				<section className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 max-w-7xl mx-auto'>
					{mentors.map((mentor, index) => (
						<div
							key={index}
							className='bg-myDark text-myLight rounded-4xl p-2 pb-6 hover:bg-myLabelText transition-colors duration-300'>
							<div className='flex justify-center'>
								<img
									src={mentor.image}
									alt={mentor.name}
									className='w-full max-w-xl rounded-3xl shadow-lg object-cover aspect-3/4 md:h-[38rem] h-60!'
								/>
							</div>

							<h3 className='text-lg font-semibold mt-4 p-1'>{mentor.name}</h3>
							<p className='text-myInputBorder p-1'>{mentor.description}</p>
						</div>
					))}
				</section>
			</main>

			<React.Suspense
				fallback={<div className='h-20 bg-gray-100 animate-pulse' />}>
				<Footer />
			</React.Suspense>
		</body>
	);
};

export default Mentors;
